export class FilterGroupFieldSettings {
  fieldName: string;

  constructor(init: Readonly<FilterGroupFieldSettings>) {
    Object.assign(this, init);
  }
}
